import { render, staticRenderFns } from "./SidebarErrors.component.html?vue&type=template&id=2b47346e&"
import script from "./SidebarErrors.component.ts?vue&type=script&lang=ts&"
export * from "./SidebarErrors.component.ts?vue&type=script&lang=ts&"
import style0 from "./SidebarErrors.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports